import axios from "axios";
import axiosClient from "./axiosClient";

const diagnose = {
  getLitDiagnose: async (params) => {
    const url = "/qlkhambenh/phieu-cdha/danh-sach-phieu-cdha";
    const response = await axiosClient.get(url, { params: params });

    return response.data;
  },
  getDetailsDiagnoseById: async (id) => {
    const url = `/qlkhambenh/phieu-cdha/chi-tiet-cdha?idPhieuCDHA=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getDetailFile: async (id) => {
    const token = localStorage.getItem("token");
    const url = `${window.REACT_APP_BE_URL}/qlkhambenh/chi-dinh-cdha/download-ket-qua?ids=${id}`;

    return url;
  },
  getListFiles: async (id) => {
    const url = `/qlkhambenh/chi-dinh-cdha/get-file?id=${id}`;
    const response = await axiosClient.get(url);

    return response.data;
  },
  getNextPatient: async () => {
    const id = `/qlkhambenh/phieu-cdha/benh-nhan-tiep-theo`;
    const res = await axiosClient.get(id);

    return res.data;
  },
  getShowFile: async (id) => {
    const url = `/qlkhambenh/chi-dinh-cdha/show-file-ket-qua?ids=${id}`;
    const res = await axiosClient.get(url);

    return res.data;
  },
  updateDetails: async (data) => {
    const params = { id: data?.id };
    const url = `/qlkhambenh/phieu-cdha`;
    const response = await axiosClient.put(url, data, { params: params });
    return response.data;
  },
  updateStatusDiagnose: async (params) => {
    const url = `/qlkhambenh/phieu-cdha/cap-nhat-trang-thai`;
    const response = await axiosClient.put(url, {}, { params: params });
    return response.data;
  },
  updateDetailsTable: async (data) => {
    const url = `/qlkhambenh/chi-dinh-cdha/luu-ket-qua`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  // upload file
  uploadFileResultDiagnose: async (id, data) => {
    const url = `/qlkhambenh/chi-dinh-cdha/upload-ket-qua`;
    const headers = { "Content-Type": "multipart/form-data" };
    const response = await axiosClient.put(url, data, {
      params: { id },
      headers: headers,
    });
    return response.data;
  },
  deletefiles: async (id) => {
    const url = `/qlkhambenh/chi-dinh-cdha/delete-file-ket-qua?ids=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  //danh mục
  getListMayCDHA: async () => {
    const url = `/qlkhambenh/danh-sach-may-cdha`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  postMayCDHA: async (data) => {
    const url = `/qlkhambenh/may-cdha`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },

  putMayCDHA: async (data) => {
    const url = `/qlkhambenh/may-cdha?id=${data.id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },

  deleteMachines: async (id) => {
    const url = `/qlkhambenh/may-cdha?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
};

export default diagnose;
